import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NavCommon from '../../components/navCommon';
import icons from '../../constants/icons';
import ForPosition from './switch/poleToPosiiton';
import InAdvance from './switch/poleToAntecipation';
import {
  BoxLoading,
  Button,
  CardForm,
  CardFormBody,
  ContainerForm,
  FooterBotton,
  Img,
  Info,
  Item,
  Loading,
  MarginLeft,
  Number,
  RowFormSelect,
  SizedBox,
  Space,
  Title,
} from './styles';
import axiosPole from '../../services/poleposition';
import axiosPlace from '../../services/place';
import axiosCriterion from '../../services/criterion';
import { Criterios, GenericPlace, TypePolePosition } from '../../interfaces';
import warn from '../../constants/toast';
import PoleBloqued from './switch/poleToBloqued';

const Places = () => {
  const history = useHistory();
  const [positions, setPositions] = useState<Array<{name: string, id: number}>>([]);

  const [isInit, setIsInit] = useState<boolean>(true);
  const [firstOption, setFirstOption] = useState<boolean>(false);
  const [secondOption, setSecondOption] = useState<boolean>(false);
  const [last, setLast] = useState<boolean>();
  const [typesOfPole, setTypesOfPole] = useState<Array<TypePolePosition>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [criterion, setCriterion] = useState<Array<Criterios>>([]);
  const [places, setPlaces] = useState<Array<GenericPlace>>([]);

  useEffect(() => {
    setPositions([
      { name: 'Incluir nome e foto', id: 0 },
      { name: 'Vantagens por posição', id: 1 },
      { name: 'Definir locais', id: 2 },
      { name: 'Definir critérios', id: 3 },
    ]);
  }, []);

  useEffect(() => {
    requestAll();
  }, []);

  const requestAll = () => {
    setLoading(true);
    Promise.all([
      requestTypePole(),
      requestGetValidCriteria(),
      requestPlace(),
    ]).then(() => {
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  const requestTypePole = async () => {
    try {
      const response = await axiosPole.GetPolepositionTypes();
      const data = response.data.data.map((item: any) => {
        item.check = false;
        return item;
      });

      data[0].check = true;

      setTypesOfPole(data);
    } catch (error: any) {
      warn.wargingError('Não foi possível obter os tipos de pole positions');
    }
  };

  const requestGetValidCriteria = async () => {
    try {
      const response = await axiosCriterion.GetValidCriteria();
      setCriterion(response.data.data);
    } catch (error: any) {
      warn.wargingError('Não foi possível obter a lista de critéios');
    }
  };

  const requestPlace = async () => {
    try {
      const response = await axiosPlace.GetValidLocations();
      setPlaces(response.data.data);
    } catch (error: any) {
      warn.wargingError('Não foi possível obter a lista de locais');
    }
  };

  const navigation = () => {
    if (typesOfPole.every((item) => item.check === false)) {
      warn.wargingAlert('Selecione uma opção!');
    } else {
      setIsInit(false);
      typesOfPole.forEach((item) => {
        if (item.check && item.codigo === 1) {
          setFirstOption(true);
          return;
        }
        if (item.check && item.codigo === 2) {
          setSecondOption(true);
        }
        if (item.check && item.codigo === 3) {
          setLast(true);
        }
      });
    }
  };

  const updateListSelect = (index: number, codigo: number) => {
    setPositions([
      { name: 'Incluir nome e foto', id: 0 },
      { name: index === 0 ? 'Vantagens por posição' : 'Dados de entrada antecipada', id: 1 },
      { name: 'Definir locais', id: 2 },
      { name: 'Definir critérios', id: 3 },
    ]);

    setTypesOfPole(typesOfPole.map((item) => {
      if (item.codigo === codigo) {
        item.check = true;
        return item;
      }
      item.check = false;
      return item;
    }));
  };

  const init = () => (
    <CardForm>
      {loading ? (
        <BoxLoading>
          <Loading />
        </BoxLoading>
      ) : (
        <>
          <CardFormBody color="#E0E9FF">
            <MarginLeft>
              <div style={{ marginBottom: 32, paddingRight: 20 }}>
                Nas próximas telas você vai executar as seguintes ações:
              </div>
              {positions.map((item: { name: string, id: number }) => (
                <Item key={item.id}>
                  <Number>
                    <div>{String(item.id + 1)}</div>
                  </Number>
                  <div>{item.name}</div>
                </Item>
              ))}
            </MarginLeft>
          </CardFormBody>
          <CardFormBody color="#fff">
            <Img height={80} width={80} src={icons.newPoleIcon} />
            <Space />
            <Title>Criar novo pole position</Title>
            <Space />
            <Info>Escolha o tipo de pole position que deseja</Info>
            <Info>Cadastrar</Info>
            <SizedBox />
            {typesOfPole.map((item, index: number) => (
              <RowFormSelect onClick={() => {
                updateListSelect(index, item.codigo);
              }}
              >
                <Img height={20} src={item.check ? icons.checkRoundIcon : icons.unCheckRoundIcon} />
                <div>{item.descricao}</div>
              </RowFormSelect>
            ))}
            <SizedBox />
            <Info>
              Cadastre um novo pole position e consiga
            </Info>
            <Info>gerenciar um novo ranking de corretores</Info>
            <FooterBotton>
              <Button
                onClick={() => {
                  navigation();
                }}
                variant="contained"
                color="primary"
              >
                COMEÇAR

              </Button>
            </FooterBotton>
          </CardFormBody>
        </>
      )}
    </CardForm>
  );

  const resetInit = () => {
    setFirstOption(false);
    setSecondOption(false);
    setLast(false);
    setIsInit(true);
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: '/polipositions', name: 'Pole positions' },
          { path: '', name: 'Novo' },
        ]}
        hasOnChange={false}
        onBack={() => { history.goBack(); }}
        setOpen={() => {}}
        open={false}
        onChange={() => {}}
      />
      <ContainerForm>
        {isInit && (init())}
        {firstOption && (
          <ForPosition
            tipoPolePosition={1}
            criterion={criterion}
            place={places}
            goInit={resetInit}
          />
        )}
        {secondOption && (
          <InAdvance
            tipoPolePosition={2}
            criterion={criterion}
            place={places}
            goInit={resetInit}
          />
        )}
        {last && (
          <PoleBloqued
            tipoPolePosition={3}
            criterion={criterion}
            place={places}
            goInit={resetInit}
          />
        )}
      </ContainerForm>
    </>
  );
};

export default Places;
